// ======================================================================
// File: src/modules/ppe/pages/orders/OrderDetailPage.js
// ======================================================================

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import ppeOrderService from "../../services/ppeOrderService";
import OrderItemBOQCard from "../../components/boq/OrderItemBOQCard";
import RoutingView from "../../components/routing/RoutingView";
import axiosClient from "../../../../api/axiosClient";
import KpiCard from "../../components/common/KpiCard";
// ✅ BOQ Operation Mapping
import BOQOperationMappingView 
  from "../../components/boq/BOQOperationMappingView";

// ----------------------------------------------------------------------
// Local status mapping (ERP-safe, no backend dependency)
// ----------------------------------------------------------------------
const STATUS_MAP = {
  1: "Draft",
  2: "Released",
  3: "In Progress",
  4: "Completed",
  5: "On Hold",
  6: "Cancelled",
};

export default function OrderDetailPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("overview");
  const [selectedMappingItemId, setSelectedMappingItemId] = useState(null);
  const [variantMap, setVariantMap] = useState({});

  // ------------------------------------------------------------------
  // Add Order Item modal state
  // ------------------------------------------------------------------
  const [showAddItem, setShowAddItem] = useState(false);

  const [newItem, setNewItem] = useState({
    item_seq_no: 1,
    product_family_id: "",
    product_variant_id: "",
    quantity: "",
    priority: 3,
  });

  const [productFamilies, setProductFamilies] = useState([]);
  const [productVariants, setProductVariants] = useState([]);

  // ------------------------------------------------------------------
  // Add Product Variant modal state
  // ------------------------------------------------------------------
  const [showAddVariant, setShowAddVariant] = useState(false);

  const [newVariant, setNewVariant] = useState({
    variant_code: "",
    variant_name: "",
    variant_type: "STANDARD",
    uom_id: "",
    drawing_required: false,
  });

  // ------------------------------------------------------------------
  // Load order + order items
  // ------------------------------------------------------------------
  const loadItems = async () => {
    const itemsRes = await ppeOrderService.listOrderItems(orderId);
    setItems(itemsRes || []);
  };

  useEffect(() => {
    async function load() {
      try {
        const res = await ppeOrderService.listOrders();
        const found = (res.items || []).find(
          (o) => String(o.id) === String(orderId)
        );
        setOrder(found || null);

        if (found) {
          await loadItems();
        }
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [orderId]);
  useEffect(() => {
  async function loadVariants() {
    const res = await axiosClient.get("/api/ppe/masters/product-variants");
    const map = {};
    (res.data.data || []).forEach(v => {
      map[v.id] = `${v.variant_code} – ${v.name}`;
    });
    setVariantMap(map);
  }

  loadVariants();
}, []);


  if (loading) return <div>Loading order…</div>;
  if (!order) return <div>Order not found</div>;

  // ------------------------------------------------------------------
  // KPI calculations
  // ------------------------------------------------------------------
  const totalQty = items.reduce(
    (sum, i) => sum + (Number(i.quantity) || 0),
    0
  );

  const boqItemCount = items.filter(
    (i) => i.boq_id || i.has_boq || i.boq_status
  ).length;

  const routedItemCount = items.filter(
    (i) => i.routing_id || i.has_routing || i.routing_status
  ).length;

  const isProductionReady =
    items.length > 0 && boqItemCount === items.length;

  // ------------------------------------------------------------------
  // Add Order Item helpers
  // ------------------------------------------------------------------
  const nextSeq =
    items.length > 0
      ? Math.max(...items.map((i) => i.item_seq_no)) + 1
      : 1;

  const openAddItem = async () => {
    setNewItem({
      item_seq_no: nextSeq,
      product_family_id: "",
      product_variant_id: "",
      quantity: "",
      priority: 3,
    });

    const pfRes = await axiosClient.get("/api/ppe/masters/product-families");
    setProductFamilies(pfRes.data.data || []);
    setProductVariants([]);

    setShowAddItem(true);
  };

  const onProductFamilyChange = async (familyId) => {
    setNewItem({
      ...newItem,
      product_family_id: familyId,
      product_variant_id: "",
    });

    if (!familyId) {
      setProductVariants([]);
      return;
    }

    const res = await axiosClient.get(
      "/api/ppe/masters/product-variants",
      { params: { product_family_id: familyId } }
    );
    setProductVariants(res.data.data || []);
  };

  const saveOrderItem = async () => {
    await ppeOrderService.createOrderItem(orderId, {
      item_seq_no: newItem.item_seq_no,
      product_variant_id: newItem.product_variant_id,
      quantity: newItem.quantity,
      priority: newItem.priority,
      status_id: 1,
    });

    setShowAddItem(false);
    await loadItems();
  };

  // ------------------------------------------------------------------
  // Save Product Variant
  // ------------------------------------------------------------------
  const saveProductVariant = async () => {
    const res = await axiosClient.post(
      "/api/ppe/masters/product-variants",
      {
        product_family_id: newItem.product_family_id,
        variant_code: newVariant.variant_code,
        variant_name: newVariant.variant_name,
        variant_type: "STANDARD",
        uom_id: 1,
        drawing_required: false,
        is_active: true,
        status_id: 1,
        tenant_id: order.tenant_id,
        location_id: order.location_id,
        created_by: order.created_by,
      }
    );

    const created = res.data;
    if (!created || !created.id) return;

    setProductVariants((prev) => [...prev, created]);
    setNewItem((prev) => ({
      ...prev,
      product_variant_id: String(created.id),
    }));

    setShowAddVariant(false);
    setNewVariant({
      variant_code: "",
      variant_name: "",
      variant_type: "STANDARD",
      uom_id: "",
      drawing_required: false,
    });
  };

  // ------------------------------------------------------------------
  // Render
  // ------------------------------------------------------------------
  return (
    <div>
      {/* HEADER */}
     {/* ORDER HEADER */}
<div
  style={{
    background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
    borderRadius: 14,
    padding: "16px 22px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  }}
>
  {/* LEFT */}
  <div>
    <div style={{ fontSize: 20, fontWeight: 700 }}>
      Order {order.order_number}
    </div>
    <div style={{ fontSize: 13, opacity: 0.9 }}>
      {order.customer_name}
    </div>
  </div>

  {/* RIGHT */}
  <button
    onClick={() => navigate("/ppe/orders")}
    style={{
      background: "#fff",
      color: "#5f0cff",
      border: "none",
      borderRadius: 8,
      padding: "8px 14px",
      fontWeight: 600,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: 6,
    }}
  >
    ← Back to Orders
  </button>
</div>


      {/* KPI ROW – GRID FIX ONLY */}
      <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 16,
    marginBottom: 24,
  }}
>
        <KpiCard title="Status" value={STATUS_MAP[order.status_id]} color="#0d6efd" />
        <KpiCard title="Order Items" value={items.length} color="#198754" />
        <KpiCard title="Total Quantity" value={totalQty} color="#fd7e14" />
        <KpiCard title="BOQ Progress" value={`${boqItemCount} / ${items.length}`} color="#6f42c1" />
        <KpiCard title="Production Ready" value={isProductionReady ? "Yes" : "No"} color={isProductionReady ? "#198754" : "#dc3545"} />
        <KpiCard title="Routing Progress" value={`${routedItemCount} / ${items.length}`} color="#0dcaf0" />
      </div>

      {/* TABS */}
      <ul className="nav nav-tabs">
        {["overview", "boq", "routing", "boq-operation"].map((t) => (
          <li className="nav-item" key={t}>
            <button
              className={`nav-link ${activeTab === t ? "active" : ""}`}
              onClick={() => setActiveTab(t)}
            >
              {t === "boq-operation" ? "BOQ-Operation" : t.toUpperCase()}
            </button>
          </li>
        ))}
      </ul>

      {/* TAB CONTENT */}
      <div className="border border-top-0 p-3">
        {activeTab === "overview" && (
          <>
            {/* ORDER ITEMS HEADER */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    background: "#f8f9fc",
    border: "1px solid #e4e7ec",
    borderRadius: 10,
    marginBottom: 12,
  }}
>
  <div style={{ fontSize: 14, fontWeight: 600, color: "#344054" }}>
    Order Items
  </div>

  <button
    onClick={openAddItem}
    style={{
      background: "linear-gradient(90deg, #0d6efd, #0b5ed7)",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      padding: "6px 12px",
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    + Add Item
  </button>
</div>


            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Seq</th>
                  <th>Variant</th>
                  <th>Qty</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id}>
                    <td>{i.item_seq_no}</td>
                    <td>{variantMap[i.product_variant_id] || `Variant #${i.product_variant_id}`}</td>
                    <td>{i.quantity}</td>
                    <td>{STATUS_MAP[i.status_id]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {activeTab === "boq" &&
          items.map((item) => <OrderItemBOQCard key={item.id} item={item} />)}

        {activeTab === "routing" && <RoutingView items={items} />}
        {activeTab === "boq-operation" && (
          <>
            {/* ================= ITEM SELECTOR ================= */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Select Order Item for Operation Mapping
              </label>

              <select
                className="form-select"
                value={selectedMappingItemId || ""}
                onChange={(e) =>
                  setSelectedMappingItemId(Number(e.target.value))
                }
              >
                <option value="">-- Select Item --</option>

                {items.map((i) => (
                  <option key={i.id} value={i.id}>
                    Item #{i.item_seq_no} —{" "}
                    {variantMap[i.product_variant_id] ||
                      `Variant #${i.product_variant_id}`}
                  </option>
                ))}
              </select>
            </div>

            {/* ================= SINGLE MAPPING VIEW ================= */}
            {selectedMappingItemId && (
              <BOQOperationMappingView
                orderItemId={selectedMappingItemId}
              />
            )}
          </>
        )}
      </div>

      {/* ADD ORDER ITEM MODAL */}
      {showAddItem && (
        <div className="modal d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Add Order Item</h5>
                <button className="btn-close" onClick={() => setShowAddItem(false)} />
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <label>Item Seq No</label>
                  <input className="form-control" value={newItem.item_seq_no} disabled />
                </div>

                <div className="mb-2">
                  <label>Product Family</label>
                  <select
                    className="form-select"
                    value={newItem.product_family_id}
                    onChange={(e) => onProductFamilyChange(e.target.value)}
                  >
                    <option value="">Select Product Family</option>
                    {productFamilies.map((pf) => (
                      <option key={pf.id} value={pf.id}>
                        {pf.code} - {pf.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-2">
                  <label className="d-flex justify-content-between">
                    Product Variant
                    <button
                      className="btn btn-sm btn-link"
                      disabled={!newItem.product_family_id}
                      onClick={() => setShowAddVariant(true)}
                    >
                      + Add Variant
                    </button>
                  </label>
                  <select
                    className="form-select"
                    value={newItem.product_variant_id}
                    disabled={!newItem.product_family_id}
                    onChange={(e) =>
                      setNewItem({ ...newItem, product_variant_id: e.target.value })
                    }
                  >
                    <option value="">Select Product Variant</option>
                    {productVariants.map((pv) => (
                      <option key={pv.id} value={pv.id}>
                        {pv.variant_code}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-2">
                  <label>Quantity</label>
                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    value={newItem.quantity}
                    onChange={(e) =>
                      setNewItem({ ...newItem, quantity: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAddItem(false)}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={
                    !newItem.product_family_id ||
                    !newItem.product_variant_id ||
                    !newItem.quantity
                  }
                  onClick={saveOrderItem}
                >
                  Save Item
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ADD PRODUCT VARIANT MODAL */}
      {showAddVariant && (
        <div className="modal d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6>Add Product Variant</h6>
                <button className="btn-close" onClick={() => setShowAddVariant(false)} />
              </div>

              <div className="modal-body">
                <div className="mb-2">
                  <label>Variant Code</label>
                  <input
                    className="form-control"
                    value={newVariant.variant_code}
                    onChange={(e) =>
                      setNewVariant({ ...newVariant, variant_code: e.target.value })
                    }
                  />
                </div>

                <div className="mb-2">
                  <label>Variant Name</label>
                  <input
                    className="form-control"
                    value={newVariant.variant_name}
                    onChange={(e) =>
                      setNewVariant({ ...newVariant, variant_name: e.target.value })
                    }
                  />
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={newVariant.drawing_required}
                    onChange={(e) =>
                      setNewVariant({
                        ...newVariant,
                        drawing_required: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label">
                    Drawing Required
                  </label>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAddVariant(false)}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!newVariant.variant_code || !newVariant.variant_name}
                  onClick={saveProductVariant}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
